import React, { Children } from 'react';
import { makeStyles } from '@material-ui/core';
import Cardbody from '@material-ui/core/CardContent';

const useStyles = makeStyles((theme) => ({
  cardBody: {
    textAlign: 'center',
    margin: '0 10px',
  },
}));

export function CardBody(props) {
  const classes = useStyles();
  const { children, ...rest } = props;
  return (
    <Cardbody className={classes.cardBody} {...rest}>
      {props.children}
    </Cardbody>
  );
}
